
import { useState, useEffect, useMemo } from "react";

import { useChampiList } from "./useChampiList";
import feuille1 from '../assets/feuille1.png'
import feuille2 from '../assets/feuille2.png'
import feuille3 from '../assets/feuille3.png'
import champi1 from '../assets/champi1.png'
import champi2 from '../assets/champi2.png'

import '../styles/ChampignonsList.css'
import ChampiItem from "./ChampiItem";
export const caracteristiqueLibelle = {
  groupe: "Groupe",
  genre: "Genre",
  espece: "Nom latin",
  chapeau_couleur: "Couleur du chapeau",
  odeur: "Odeur",
  saveur: "Saveur",
  habitat: "Habitat",
  lame_couleur: "Couleur des lames",
  chair_lait: "Chair / Lait",
  sporee_couleur: "Couleur de la sporée",
  comestible: "Comestible"
};

function ChampignonsList() {
  const [search, setSearch] = useState("");
  const [selectedList, setSelectedList] = useState([]);  
  const [showDropdown, setShowDropdown] = useState(false);
  const [champignonDuJour, setChampignonDuJour] = useState(null);
  const champiList = useChampiList();
const rainImages = [feuille1, feuille2, feuille3, champi1, champi2]

 const selectedIds = new Set(selectedList.map(c => c.id));

useEffect(() => {
  if (champiList.length === 0) return;

  const randomIndex = Math.floor(Math.random() * champiList.length);
  setChampignonDuJour(champiList[randomIndex]);
}, [champiList]);


const getGlobalCommons = (selectedList) => {
  if (selectedList.length === 0) return {};

  const result = {};

  Object.keys(caracteristiqueLibelle).forEach((key) => {
    const allValues = selectedList
      .flatMap(c => c.commons?.[key] || []);

    if (allValues.length > 0) {
      // suppression des doublons
      result[key] = [...new Set(allValues)];
    }
  });


  return result;
};

const globalCommons = useMemo(
  () => getGlobalCommons(selectedList),
  [selectedList]
);


const getCommonCharacteristics = (selected, daily) => {
  const commons = {};
  
    Object.keys(caracteristiqueLibelle).forEach((key) => {
    if (!selected[key] || !daily[key]) return;

    const selectedValues = selected[key].split(",").map(v => v.trim().toLowerCase());
    const dailyValues = daily[key].split(",").map(v => v.trim().toLowerCase());

    const intersection = selectedValues.filter(v => dailyValues.includes(v));
    if (intersection.length > 0) {
      commons[key] = intersection;
    }
  });

  return commons; // { chapeau_couleur: ["brun"], habitat: ["sous feuillus"] }

};

const removeAccents = (str) =>
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

const filtered = champiList
  .filter(c => !selectedIds.has(c.id))
  .filter(c =>
    removeAccents(c.nom.toLowerCase()).includes(removeAccents(search.toLowerCase()))
  );
const [isWin, setIsWin] = useState(false);

const handleSelect = (c) => {
  if (!champignonDuJour) return;

  // Calcul des points communs
  const commons = getCommonCharacteristics(c, champignonDuJour);
if (c.id === champignonDuJour.id) {
  setIsWin(true);
}

  const champiWithCommons = { ...c, commons };
  setSelectedList((prev) => [champiWithCommons, ...prev]);

  setShowDropdown(false);
  setSearch("");
};

  return (

    <div className="mycoquiz-search-wrapper">

    {isWin && (
      <>
        <div className="mycoquiz-win-message">
          Mes félicitations champipote, tu as trouvé le champignon à deviner !
        </div>
       <div className="mushroom-rain">
      {[...Array(25)].map((_, i) => (
        <span
          key={i}
          className="mushroom"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 3}s`,
            fontSize: `${20 + Math.random() * 30}px`
          }}
        >
          🍄
        </span>
      ))}
    </div>
        </>
      )}

      {!isWin && Object.keys(globalCommons).length > 0 && (
        <div className="mycoquiz-commons">
          <h3 className="mycoquiz-commons-title">Caractéristiques en commun</h3>
          <ul>
            {Object.entries(globalCommons).map(([key, values]) => (
              <li key={key}>
                <strong>{caracteristiqueLibelle[key]} :</strong>{" "}
                {values.join(", ")}
              </li>
            ))}
          </ul>
        </div>
      )}
    
    {!isWin && (
      <div className="mycoquiz-search-wrapper" style={{ position: "relative" }}>
        <input
          type="text"
          placeholder="Propose un champignon !"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setShowDropdown(true);
          }}
          className="mycoquiz-search-bar"
        />

        {showDropdown && search.length > 0 && (
          <div className="mycoquiz-dropdown">
            {filtered.map((c) => (
              <div
                key={c.id}
                className="mycoquiz-dropdown-item"
                onClick={() => handleSelect(c)}
              >
                <img src={c.cover} className="mycoquiz-dropdown-img" />
                <span>{c.nom}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    )}

    {/* La liste des champi items */}
    <ul className="champi-list">
      {selectedList.map((champi) => (
        <ChampiItem
          key={champi.id}
          champiDuJourId={champignonDuJour.id}
          {...champi}
        />
      ))}
    </ul>
    </div>
  );
}




export default ChampignonsList;
